import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { ActionType, PaymentCardType } from '../../types/chat.types';

interface PaymentCardProps {
  card: PaymentCardType;
  handleFormSubmit: (response: any) => void;
}

const PaymentCard: React.FC<PaymentCardProps> = ({
  handleFormSubmit,
  card,
}) => {
  const connectionStatus = useSelector(
    (state: RootState) => state.socketConnection.status,
  );
  const [select, setSelect] = useState('');

  const {
    title,
    description,
    selectionHeading,
    selectionOptions = [],
    actions,
  } = card;

  return (
    <div>
      <div className="pb-4 ">{title}</div>
      <div className=" pb-4 ">{description}</div>
      <div className="flex flex-wrap  my-3 justify-between">
        <div className="1/4">
          {selectionHeading} <span className="px-3"> : </span>
        </div>
        <div className="inline-block w-3/5">
          <select
            className="block appearance-none w-full bg-white border-2 border-gray-300 hover:border-secondary px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
            name={selectionHeading}
            value={select}
            disabled={connectionStatus !== 'Connected'}
            onChange={(e) => {
              setSelect(e.target.value);
            }}
          >
            {selectionOptions.map(({ value, name }, index) => (
              <option key={index} value={value}>
                {name}
              </option>
            ))}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>
      <div className="pb-4 "> {'<iFrame with Payment >'} </div>
      <div className="flex flex-row-reverse">
        {actions.map((action: ActionType) => {
          return (
            <button
              key={`action-${action.title}`}
              type="submit"
              disabled={connectionStatus !== 'Connected'}
              className={`bg-primary text-white p-2 mx-2 rounded-lg w-1/6 mt-4 enabled:hover:bg-blue-700`}
              onClick={() => {
                handleFormSubmit(action.actionType);
              }}
            >
              {action.title}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default PaymentCard;
